import { render, staticRenderFns } from "./ProductsSwiper.vue?vue&type=template&id=4a1b68c4&"
import script from "./ProductsSwiper.vue?vue&type=script&lang=js&"
export * from "./ProductsSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports